module.exports = __webpack_public_path__ + "static/media/ElWoman.34ec2d9c.png";